import {api} from './requestGraphql'
import request from "./request";
import {getCookie} from "../helpers";

const getPixelLog = async (data) => {
    try {
        let preparedFilters = ''

        for (const filter in data.payload.filters) {
            preparedFilters += (!!data.payload.filters[filter]) ?
                `${filter}: "${data.payload.filters[filter]}"` : ''
        }
        const res = await api.post(
            '', {
                query: `
                {
                  pixels(
                   pagination: {
                      page: ${data.payload.page},
                      limit: ${data.payload.limit}
                    }, sorting: {
                      orderBy: "${data.payload.orderBy}",
                      orderDirectionAsc: ${data.payload.orderDirectionAsc}
                    }, filters: {
                    ${preparedFilters}
                    }, period:{
                      start: ${data.payload.fromDate},
                      end: ${data.payload.toDate}
                    }) {
                    count,
                    data {
                       id
                       ip
                       url
                       dateAdded
                       offerName
                       advertiserName
                       status
                       rejectedReason
                    }
                  }
                }
        
                `,
            }
        )
        return {
            data: res.data.data.pixels.data,
            count: res.data.data.pixels.count
        }
    } catch (e) {
        console.error(e)
    }
}

const getFilter = async (data) => {
    const preparedFilter = []
    if(data.filter) {
        for (let i = 0; i < data.filter.length; i++) {
            preparedFilter.push(
                (!!data.filter[i]) ? `{ field: "${data.filter[i].field}", value: [${data.filter[i].value.map(v => `"${v}"`)}] }` : ''
            )
        }
    }

    data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''

    const result = await request.post(`/graphql`, {
            query: `
          {
            pixelFilterData(name: "${data.name}", searchFilter: "${data.searchFilter || ''}", ${data.filter}) {
              key,
              value
            }
          }
        `
        },
        {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        }
    )
    if(result.status === 200) {
        const prettyData = [];
        if(result.data.data.pixelFilterData) {
            for(let i = 0; i < result.data.data.pixelFilterData.length; i++) {
                if(result.data.data.pixelFilterData[i].value !== null){
                    prettyData.push(result.data.data.pixelFilterData[i]);
                }
            }
            return prettyData;
        }
    }
}
const getPixelsLogs = async (lid) => {
    try {
        const res = await api.post(
            '', {
                query: `
                {
                  getPixelsLogs(lid: "${lid}") {
                    id
                    lid
                    offerId
                    campaignId
                    advertiserId
                    ip
                    url
                    status
                    rejectReason
                    dateAdded
                  }
                }
              `,
            }
        )
        return res.data.data.getPixelsLogs;
    } catch (e) {
        console.error(e);
    }
}

const getSaleByLid = async (lid) => {
    try {
        const res = await api.post(
            '', {
                query: `
                {
                  getSaleByLid(lid: "${lid}") {
                    id
                    isFired
                    dateAdded
                    payout
                    payin
                    advertiser
                    segmentAmount
                    affiliateId
                    offerId
                    lid
                    conversionType
                    currencyRate
                    programId
                    campaignId
                    subId
                    geo
                    advertiserId
                    saleHistory {   
                      id
                      saleId
                      entity
                      user
                      action
                      dateAdded
                      logs
                    }
                  }
                }
              `,
            }
        )
        return res.data.data.getSaleByLid;
    } catch (e) {
        console.error(e);
    }
}



export default {
    getPixelLog,
    getFilter,
    getPixelsLogs,
    getSaleByLid
}